import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import alternativeProductsQuery from './query'
import {
  IAlternativeProductsVariables,
  IAlternativeProductsResponse,
} from './types'

/**
 * Hook declaration to obtain a lazy query of the "Opciones similares"
 * (alternative / similar) products for the displayed product-detail SKUs.
 * @param options: LazyQueryHookOptions
 * @internal
 */
const useLazyAlternativeProducts = (
  options?: LazyQueryHookOptions<
    IAlternativeProductsResponse,
    IAlternativeProductsVariables
  >,
) => {
  return useLazyQuery<
    IAlternativeProductsResponse,
    IAlternativeProductsVariables
  >(alternativeProductsQuery, {
    fetchPolicy: 'no-cache',
    ...options,
  })
}

export { useLazyAlternativeProducts }
